import { render, staticRenderFns } from "./UploadAudio.vue?vue&type=template&id=6451df8c&scoped=true&"
import script from "./UploadAudio.vue?vue&type=script&lang=js&"
export * from "./UploadAudio.vue?vue&type=script&lang=js&"
import style0 from "./UploadAudio.vue?vue&type=style&index=0&id=6451df8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6451df8c",
  null
  
)

export default component.exports